import getUserConfiguration from '../actions/getUserConfiguration';
import { isFeatureEnabled } from 'owa-feature-flags';

export default function getDefaultOnlineMeetingEnabled(): boolean {
    let onlineMeetingEnabled = false;

    if (isFeatureEnabled('cal-mf-enableDefaultOnlineMeetingSetting')) {
        const userConfig = getUserConfiguration();

        onlineMeetingEnabled = userConfig
            ? !!userConfig.UserOptions?.AddOnlineMeetingToAllEvents
            : false;
    }

    return onlineMeetingEnabled;
}
